module.exports = __webpack_public_path__ + "static/img/presysv21Two.1da7192.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/presysv21Two.png
// module id = oAQ8
// module chunks = 1